module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.cards) ? _c('span', _vm._l((_vm.cards), function(line, index) {
    return _c('b-row', {
      key: 'line' + index
    }, _vm._l((line), function(card, index) {
      return _c('b-col', {
        key: 'card' + index
      }, [_c('b-card', {
        staticClass: "center",
        style: (card.color ? ("color:" + (card.color) + ";") : ''),
        attrs: {
          "title": card.value,
          "text-variant": card.variant ? card.variant : ''
        }
      }, [_c('b-card-text', {
        staticClass: "center"
      }, [_vm._v("\n            " + _vm._s(card.label) + "\n          ")])], 1)], 1)
    }), 1)
  }), 1) : _c('span', _vm._l(([1, 2]), function(line) {
    return _c('b-row', {
      key: line
    }, _vm._l(([1, 2, 3, 4]), function(card) {
      return _c('b-col', {
        key: card
      }, [_c('b-card', {
        staticClass: "center"
      }, [_c('skeleton-loader', {
        staticStyle: {
          "margin-bottom": "14px"
        },
        attrs: {
          "height": "28px",
          "width": "50px"
        }
      }), _vm._v(" "), _c('br'), _vm._v(" "), _c('skeleton-loader', {
        staticStyle: {
          "margin-bottom": "14px"
        },
        attrs: {
          "height": "19px",
          "width": "150px"
        }
      })], 1)], 1)
    }), 1)
  }), 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-091f33de", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-091f33de","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/statistics/components/MarketPlace/StatCards.vue
// module id = 2323
// module chunks = 2